/*
*
* File JS componente Block Video
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-video-tabs.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockVideoTabs = () => {
    const context = document.querySelector('.block-video-tabs');
    if(!context) return;

    const headerTabs = context.querySelectorAll('.tabs__header > a');
    const contentTabs = context.querySelectorAll('.tabs__content > div');
    if(!headerTabs || !contentTabs) return;


    headerTabs.forEach(item => {

        item.addEventListener('click' , (e) => {
            e.preventDefault();
            const currentDatTab = item.getAttribute('data-tab');

            if(currentDatTab)  {
                const contentToShow = context.querySelector(`.tabs__content [data-tab='${currentDatTab}']`);
                toggleContentTabs(contentToShow);
                toggleHeader(item);
            }

        })

    });

    function toggleContentTabs(showTab){
        contentTabs.forEach(item => {
            item.classList.remove('active');
        });

        showTab.classList.add('active');
    }

    function toggleHeader(showHeader)
    {
        headerTabs.forEach(item => {
            item.classList.remove('active');
        });

        showHeader.classList.add('active');
    }

}

export default blockVideoTabs;

//--------------------------------------------------------------------//